// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : viewer actions (animation stuff with sagas)
// =============================================================================
// ---Third-party imports

// ---Framework imports
import {SILENT, TIMESTAMP, GENERATOR, combine, COPY2PAYLOAD, createAction} from 'uix/actions'

let createSmoothScroll = options => {
  let {start, end, startZoom, endZoom, duration} = options
  if (!duration) {
    options.duration = 1
  }

  if (!end && start) {
    options.end = start
  }

  if (!endZoom && startZoom) {
    options.endZoom = startZoom
  }

  return options
}
let GENERATE = GENERATOR('animationId')
export const smoothScroll = createAction(
  'SMOOTH_SCROLL',
  createSmoothScroll,
  combine(GENERATE, TIMESTAMP)
)
export const animationDone = createAction('SMOOTH_SCROLL_DONE', (viewerId, animationId) => ({
  viewerId,
  animationId,
}))

export const runMorph = createAction('RUN_MORPH', options => ({...options}), GENERATE)

export const smoothScrollSeq = createAction('SMOOTH_SCROLL_SEQ', options => ({...options}))

export const sendFrame = createAction('VIEWER_FRAME', data => ({...data}), SILENT)

export const setImageControl = createAction(
  'SET_IMAGE_CONTROL',
  (src, state) => ({src, state}),
  SILENT
)

export const clearInbookSearch = createAction('CLEAR_INBOOK_SEARCH', viewerId => ({viewerId}))
export const setInbookSearch = createAction('SET_INBOOK_SEARCH', (viewerId, searchData) => ({
  viewerId,
  searchData,
}))

export const getI3F = createAction('GET_I3F', ({manifest}) => ({manifest}))
export const setI3F = createAction('SET_I3F', ({manifest, data}) => ({manifest, data}))

export const setViewerGeometry = createAction(
  'SET_VIEWER_GEOMETRY',
  (viewerId, geometry) => ({
    viewerId,
    geometry,
  }),
  (vid, g, silent = false) => ({silent})
)

export const setFocusedViewerGeometry = createAction(
  'SET_FOCUSED_VIEWER_GEOMETRY',
  (viewerId, otid, geomtype, index) => ({
    viewerId,
    otid,
    geomtype,
    index,
  }),
  SILENT
)
export const clearFocusedViewerGeometry = createAction('CLEAR_VIEWER_GEOMETRY_SELECTED')

export const setSelectedViewerGeometry = createAction(
  'SET_SELECTED_VIEWER_GEOMETRY',
  (viewerId, otid, geomtype, items, clearOther = false) => ({
    viewerId,
    otid,
    geomtype,
    items,
    clearOther,
  })
)

export const setModifiedViewerGeometry = createAction(
  'SET_MODIFIED_VIEWER_GEOMETRY',
  (viewerId, otid, geomtype, items, merge = true) => ({
    viewerId,
    otid,
    geomtype,
    items,
    merge,
  })
)
